import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F6865F",
      "fill-rule": "evenodd",
      d: "M6 12A6 6 0 1 1 6 0a6 6 0 0 1 0 12m2.4-5.25a.75.75 0 1 0 0-1.5H3.6a.75.75 0 1 0 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }